export enum ButtonType {
    'Ok',
    'Cancel'
}
